import { MenuItem } from '~/layout/types/MenuItem';
import { Icon } from '~/global/components/icon/Icon';
import { Text } from '@/components/ui/text';
import { SidebarItem } from '~/layout/components/sidebar-item/SidebarItem';
import { Link, usePathname } from 'expo-router';
import { cn } from '@/lib/utils';
import { useColor } from '~/global/hooks/useColor';
import { useState } from 'react';

export type SidebarMenuItemProps = MenuItem & {};

export const SidebarMenuItem = ({ ...item }: SidebarMenuItemProps) => {
  const pathname = usePathname();
  const isActive =
    pathname === item.href ||
    (item.href !== '/' && pathname.startsWith(item.href));
  const [isHovered, setIsHovered] = useState(false);
  const accentColor = useColor('accent');
  const secondaryColor = useColor('text-secondary');

  const iconColor = isActive || isHovered ? accentColor : secondaryColor;

  return (
    <Link href={item.href} asChild>
      <SidebarItem
        testID={`nav-${item.id}`}
        onHoverIn={() => setIsHovered(true)}
        onHoverOut={() => setIsHovered(false)}
        visual={
          <Icon
            name={item.icon!}
            className="w-5 h-5"
            size={20}
            color={iconColor}
          />
        }
        textClassName={cn(
          'text-[15px] font-inter-regular',
          isActive || isHovered ? 'text-accent' : 'text-text-secondary',
        )}
      >
        <Text>{item.label}</Text>
      </SidebarItem>
    </Link>
  );
};
